import React from 'react'
import 'bootstrap/dist/css/bootstrap.min.css'
import './App.css'
import { Container } from 'react-bootstrap'

import Header from './Header'
import Projects from './Projects'
import SkillsGroup from './SkillsGroup'
import Footer from './Footer'

function App() {
  return (
    <div className='App'>
      <Header />

      <div className='mb-4'>
        <Container>
          <Projects />

          <SkillsGroup />
        </Container>
      </div>
      <Footer />
    </div>
  )
}

export default App
